import React from 'react';
import PropTypes from 'prop-types';
import {Route, Redirect} from 'react-router-dom';

const PrivateRoute = ({component: Component, condition, redirectTo, ...rest}) => {
	return (
		<Route
			{...rest}
			render={props =>
				condition ? (
					<Component {...props} />
				) : (
					<Redirect to={{pathname: redirectTo, state: {from: props.location}}} />
				)
			}
		/>
	);
};

PrivateRoute.propTypes = {
	component: PropTypes.elementType,
	condition: PropTypes.bool,
	redirectTo: PropTypes.string,
	path: PropTypes.string,
};

export default PrivateRoute;
